<div class="topHeader">
  <div class="mobMenu" (click)="changeToggleEvent()"> 
    <span id="buttonThreeDots" class="threedots">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </div>
<!-- Header Loader Plagiarism -->
  <div class="headerLoader" *ngIf="checkingPlag && storyFLag !== 'dash'">
  <div class="progressPlag-bar">
    <span class="barPlag">
      <span class="progressPlag"></span>
    </span>
  </div>
  <i>Checking For Plagiarism</i>
</div>
<!-- Header Loader Plagiarism -->
  <div class="mlogo"><a id="appLogo" routerLink="{{config.get('imageUrls').router_link}}">
      <img src="{{config.get('imageUrls').productLogoUrl}}" alt=""></a> </div>
  <div class="rightBlock" *ngIf="domainConfig">
    <ul>
      <!--li
        *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('breaking') > -1 && storyFLag == 'dash' &&  shownav != 'nav' && pageName != 'elementheader' && pageName != 'userManagement'">
        <div class="notificationBtn"><span (click)="openBreakingNews()">Breaking News</span></div>
      </li-->
      <!--li *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('webengage') > -1 && storyFLag == 'dash' &&  shownav != 'nav' && pageName != 'elementheader' && pageName != 'userManagement'">
        <div class="notificationBtn"><span (click)="sendNotifications()">Send Notification</span></div>
      </li-->
      <!--li
        *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('flash') > -1 && storyFLag == 'dash' &&  shownav != 'nav' && pageName != 'elementheader' && pageName != 'userManagement'">
        <div class="notificationBtn"><span (click)="sendFlashNotifications()">Send Flash</span></div>
      </li-->
      <li *ngIf="storyFLag === 'story'">
        <div class="shortcuts"><span (click)="openPreviewShortcuts(itemShortcut)">?</span></div>
      </li>
      <li *ngIf="shownav == 'nav' && domain !== '5c1c93e66a2ec202bb648bbb' && pageName != 'userManagement'">
        <button type="button" id="hamburgerButton" name="createCard" class="createCard"
          routerLink='/dash/nav-manager/topnav'>Hamburger</button>
          <!-- (click)="open_new('/dash/nav-manager/topnav', 'hamburger')" -->
      </li>
      <!-- '/dash/nav-manager/l1'
      '/dash/nav-manager/l2'
      '/dash/nav-manager/l3'
     "/dash/footer-manager/topnav"
     -->
      <li class="showNavigation" *ngIf="shownav == 'nav' && domain !== '5c1c93e66a2ec202bb648bbb' && pageName != 'userManagement' && !!pageNavigationList">
        <span class="navIcon">Navigations</span>
        <ul class="navList">
          <li *ngFor="let navList of pageNavigationList">
            <button type="button" id="{{navList.id}}" name="createCard" class="createCard"
              routerLink="{{navList.router}}">{{navList.name}} </button>
          </li>
        </ul>
      </li>
      <ng-container *ngIf="storyFLag !== 'dash' && storyFLag !== 'video'">
        <li>
          <span id="textAllChangesSaved" class="created">{{changesFlag ? 'SAVING CHANGES...': 'ALL CHANGES ARE SAVED'}}</span>
          <button id="saveButton" *ngIf="storyFLag === 'story'" [class]="!saveFlag ? 'blue' : ''" (click)="sendSaveRequest()"
            [disabled]="saveFlag">Save</button>
          <button id="buttonPublish" [class]="!publishButtonFlag ? 'green' : ''" (click)="sendPublishCommand(storyFLag)"
            [disabled]="publishButtonFlag || checkingPlag">Publish</button>
        </li>
      </ng-container>

      <ng-container *ngIf="storyFLag == 'dash'">
        <ng-container *ngFor="let button of config.getButtons(config.get('views'),pageName)">
          <li>
            <ng-container *ngIf="button.type === 'route'">
              <button type="button" [id]="button.id" [hidden]="(button.active == 0)? true: false" [class]="button.class"
                [routerLink]="button.router_link">{{button.name}}</button>
            </ng-container>
            <ng-container *ngIf="domain === '5c1c93e66a2ec202bb648bbb' && button.type !== 'route' && shownav == 'nav'">
              <button type="button" [id]="button.id" [hidden]="(button.active == 0)? true: false" [class]="button.class"
                [routerLink]="button.router_link">{{button.name}}</button>
            </ng-container>
            <ng-container *ngIf="button.type === 'button'">
              <button type="button" [id]="button.id" [hidden]="(button.active == 0)? true: false" [class]="button.class"
                (click)="open_new('/lite'+button.button_link, button.name)">{{button.name}}</button>
            </ng-container>
            <div *ngIf="button.options && button.options.length > 0" class="storytype">
              <ul>
                <ng-container *ngFor="let option of button.options">
                  <li
                    *ngIf="((option && option.storyType && disabledStoryTypes) ?
                     (disabledStoryTypes.indexOf(option.storyType) === -1) : 
                     ((option && option.elementType && elementsDisabled) ?
                      (elementsDisabled.indexOf(option.elementType) === -1) : 
                      ((option && option.pageType && pagesDisabled) ?
                      (pagesDisabled.indexOf(option.pageType) === -1) : 
                      true)))">
                    <ng-container *ngIf="option.type === 'route'">
                      <button type="button" id="{{option.id}}" name="standard" class="standard"
                        (click)="snowplowAnalytics(option.router_link, option.name)" [routerLink]="option.router_link">
                        {{option.name | titlecase}}</button>
                    </ng-container>
                    <ng-container *ngIf="option.type === 'button'">
                      <button id="{{option.id}}" type="button" name="standard" class="standard"
                        (click)="open_new('/lite'+option.button_link, option.name)" >{{option.name  | titlecase}}</button>
                    </ng-container>
                  </li>
                </ng-container>
              </ul>
            </div>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
<div class="mobileMenu" [ngClass]="statusMenu ? 'active' : ''">
  <!--<div class="close fl spImg"></div> -->
  <aside class="liteleftMenu"></aside>
  <div class="close fr" (click)="closeMobileMenu()"><i class="icon-close"></i></div>
</div>
<ng-container *ngIf="openShortcutsPreview">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="lightContent">
      <div class="headerLight">
        <div class="close fr" (click)="closePreviewShortcuts()"><i class="icon-close"></i></div>
      </div>
      <div class="shortcutkeyblock">
        <ul>
          <li class="head">
            <div class="shortkeydes">Task</div>
            <div class="shortkey">
              <!--Keyboard Shortcut<br>-->
              <div class="shortkeyWin">Windows Shortcut</div>
              <div class="shortkeyMac">Mac Shortcut</div>
            </div>
          </li>
          <li>
            <div class="shortkeydes">Hyperlink</div>
            <div class="shortkeyWin">Ctrl + Shift + H</div>
            <div class="shortkeyMac">Ctrl + Shift + H</div>
          </li>
          <li>
            <div class="shortkeydes">FAQs / How-to Hyperlink</div>
            <div class="shortkeyWin">Ctrl + K</div>
            <div class="shortkeyMac">Cmd + K</div>
          </li>
          <li>
            <div class="shortkeydes">Topic Hyperlink</div>
            <div class="shortkeyWin">Ctrl + Shift + Y</div>
            <div class="shortkeyMac">Ctrl + Shift + Y</div>
          </li>
          <li>
            <div class="shortkeydes">Save</div>
            <div class="shortkeyWin">Ctrl + S</div>
            <div class="shortkeyMac">Ctrl + S</div>
          </li>
          <li>
            <div class="shortkeydes">Bold</div>
            <div class="shortkeyWin">Ctrl + B</div>
            <div class="shortkeyMac">Cmd + B</div>
          </li>
          <li>
            <div class="shortkeydes">Italics</div>
            <div class="shortkeyWin">Ctrl + I</div>
            <div class="shortkeyMac">Cmd + I</div>
          </li>
          <li>
            <div class="shortkeydes">Close window</div>
            <div class="shortkeyWin">Esc</div>
            <div class="shortkeyMac">Esc</div>
          </li>
          <li>
            <div class="shortkeydes">Publish</div>
            <div class="shortkeyWin">Ctrl + Shift + P</div>
            <div class="shortkeyMac">Ctrl + Shift + P</div>
          </li>
          <li>
            <div class="shortkeydes">Numbered list </div>
            <div class="shortkeyWin">Ctrl + Shift + 1</div>
            <div class="shortkeyMac">Ctrl + Shift + 1</div>
          </li>
          <li>
            <div class="shortkeydes">Bulleted list </div>
            <div class="shortkeyWin">Ctrl + Shift + 2 </div>
            <div class="shortkeyMac">Ctrl + Shift + 2 </div>
          </li>
          <li>
            <div class="shortkeydes">Go to metadata</div>
            <div class="shortkeyWin">Ctrl + M</div>
            <div class="shortkeyMac">Ctrl + M</div>
          </li>
          <li>
            <div class="shortkeydes">Move from one field to another</div>
            <div class="shortkeyWin">Tab</div>
            <div class="shortkeyMac">Tab</div>
          </li>
          <li>
            <div class="shortkeydes">Toggle or mark/unmark</div>
            <div class="shortkeyWin">Space</div>
            <div class="shortkeyMac">Space</div>
          </li>
          <li>
            <div class="shortkeydes">Next state</div>
            <div class="shortkeyWin">Ctrl + Shift + F</div>
            <div class="shortkeyMac">Ctrl + Shift + F</div>
          </li>
          <li>
            <div class="shortkeydes">Increase BlankPaper size</div>
            <div class="shortkeyWin">Ctrl + "+"</div>
            <div class="shortkeyMac">Cmd + "+"</div>
          </li>
          <li>
            <div class="shortkeydes">Decrease BlankPaper size</div>
            <div class="shortkeyWin">Ctrl + "-" in</div>
            <div class="shortkeyMac">Cmd + "-"</div>
          </li>
          <li>
            <div class="shortkeydes">Rupee symbol</div>
            <div class="shortkeyWin">Ctrl + Shift + 4</div>
            <div class="shortkeyMac">Ctrl + Shift + 4</div>
          </li>
          <li>
            <div class="shortkeydes">Toggle Uppercase and Lowercase</div>
            <div class="shortkeyWin">Shift + F3</div>
            <div class="shortkeyMac">Fn + Shift + F3</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="openSendNotificationPopup">
  <div class="lightBox sendFlashNotifications" style="display:block;">
    <div class="notificationWindow">
      <div class="unlockStory">
        <div class="wid100 pad30">
          <h3>Send Flash Notification</h3>
          <label>Headline<i class="mandate">*</i></label>
          <textarea class="textBox" [(ngModel)]="notificationHeadLine" placeholder="Enter the headline here…"
            type="text"></textarea>
          <label>Image</label>
          <div class="dataField">
            <div class="flashImg">
              <div class="imagepreloader" *ngIf="showLoader || croppingInProgress">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
              <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                [src]="(currentImageData !== null && currentImageData.image.images !== null) ? sharedService.getImageOnPriority(currentImageData.image.images, '960x540') : null"
                (load)="imgLoaded($event)" alt="">
              <div class="uploadimage"><i class="icon-upload"></i>
                <div class="upload-btn-wrapper relative">
                  <span class="btn">Upload Image</span>
                  <input type="file" accept="image/*" name="myfile" (change)="onFileChange($event)" />
                </div>

              </div>
            </div>
            <div class="storyaction" *ngIf="(currentImageData !== null && currentImageData.image.images !== null)">
              <span class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
              <span class="deleteHeadline" (click)="currentImageData = null;"><i class="icon-delete"></i></span>
            </div>
          </div>
          <label>Target Applications</label>
          <ul>
            <li *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('app') > -1">
              <label class="checkblock" tabindex="0">App
                <input type="checkbox" (click)="toggleSwitch('mobile')" [checked]="socialMap.mobile">
                <span class="checkmark"></span>
              </label>
            </li>
            <li *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('web') > -1">
              <label class="checkblock" tabindex="0">Desktop
                <input type="checkbox" (click)="toggleSwitch('web')" [checked]="socialMap.web">
                <span class="checkmark"></span>
              </label>
            </li>
          </ul>
        </div>
        <div class="fr wid100 right padlr30 ptb15">
          <button class="cancel gray ml10" name="cancel" routerLink="/dash/workspace"
            (click)="closesendFlashNotifications()" type="button">Cancel</button>
          <button class="add blue ml10 " name="send" type="button" (click)="sendFlashNotification()"
            [disabled]="sendingNotification">Send</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="breakingNewsListingPopup">
  <div class="lightBox breakingNewsList" style="display: block;">
    <div class="headerLight">
      <div class="close fl spImg"></div>
    </div>
    <div class="lightContent">
    <app-breaking-news-listing></app-breaking-news-listing>
    <div class="right">
      <button class="cancel gray ml10" name="cancel" (click)="closeBreakingNewsListing()">Cancel</button>
    </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="breakingNewsPopup">
  <div class="lightBox breakingNewsNotifications" style="display:block;">
    <div class="breakingNewsWindow">
      <div class="unlockStory">
        <div class="wid100 pad30 fr">
          <h3>Send Breaking News</h3>
          <label>Headline<i class="mandate">*</i></label>
          <textarea class="textBox" [(ngModel)]="notificationHeadLine" placeholder="Enter the headline here…"
            type="text"></textarea>
            <label>URL</label>
          <textarea class="textBox" [(ngModel)]="notificationUrl" placeholder="Enter the URL here…"
            type="text"></textarea>
          <label>Image</label>
          <div class="dataField">
            <div class="flashImg">
              <div class="imagepreloader" *ngIf="showLoader || croppingInProgress">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
              <img [style.visibility]="loaded ? 'visible' : 'hidden'"
                [src]="(currentImageData !== null && currentImageData.image.images !== null) ? sharedService.getImageOnPriority(currentImageData.image.images, '960x540') : null"
                (load)="imgLoaded($event)" alt="">
              <div class="uploadimage"><i class="icon-upload"></i>
                <div class="upload-btn-wrapper relative">
                  <span class="btn">Upload Image</span>
                  <input type="file" accept="image/*" name="myfile" (change)="onFileChange($event)" />
                </div>

              </div>
            </div>
            <div class="storyaction" *ngIf="(currentImageData !== null && currentImageData.image.images !== null)">
              <span class="cropimage" (click)="startCropping()"><i class="icon-crop"></i></span>
              <span class="deleteHeadline" (click)="currentImageData = null;"><i class="icon-delete"></i></span>
            </div>
          </div>
          <label>Push Notifications</label>
          <ul>
            <li *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('app') > -1">
              <label class="checkblock" tabindex="0">App
                <input type="checkbox" (click)="toggleSwitch('mobile')" [checked]="socialMap.mobile">
                <span class="checkmark"></span>
              </label>
            </li>
            <li *ngIf="domainConfig.notificationPlatformsEnabled.indexOf('web') > -1">
              <label class="checkblock" tabindex="0">Desktop
                <input type="checkbox" (click)="toggleSwitch('web')" [checked]="socialMap.web">
                <span class="checkmark"></span>
              </label>
            </li>
          </ul>
        </div>
        <div class="fr wid100 right padlr30 ptb15">
          <button (click)="openBreakingNewsListing()">Show Previous Breaking News</button>
          <button class="cancel gray ml10" name="cancel" routerLink="/dash/workspace" (click)="closeBreakingNews()"
            type="button">Cancel</button>
          <button class="add blue ml10 " name="send" type="button" (click)="sendBreakingNews()"
            [disabled]="sendingNotification">Send</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="image-cropper" *ngIf="showCropper" [cropperImageUrl]="cropperImageUrl" (finish)="finishCropping($event)"
  (cancel)="cancelCropping($event)"></div>

  <ng-container *ngIf="openSegmentPopup">
  <div class="lightBox sendNotifications" style="display:block;">
    <div class="notificationWindow">
      <div class="unlockStory">
        <div class="">
          <div class="sendNotification wid100 pad30">
            <ul class="twoLi">
              <li [class]="mandatoryFieldSegment ? 'errorInput' : ''">
                <label for="segmentName" class="control-label">Segment Name</label>
                <input id="segmentName" name="segmentName" class="form-control" type="text" value="" size="20" maxlength="50" [(ngModel)]="newSegment">
              </li>
            </ul>
          </div>
          <div class="fr wid100 right padlr30 ptb15">
          <button class="cancel gray ml10" name="cancel" (click)="closeCreateSegmentPopup()" type="button">Cancel</button>
          <button class="add blue ml10 " name="send" type="button" (click)="createSegment()">Add</button>
        </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
  

  <ng-container *ngIf="openNotificationPopup">
    <div class="lightBox sendNotifications" style="display:block;">
      <div class="notificationWindow">
        <div class="unlockStory">
          <div class="wid100 pad30">
            <div class="headerBlock" id="sendNotificationButton">
            <h3 class="flSendNoti">Send Notification</h3>

            <ng-container *ngIf="enableMoEngage">
              <div class="scheduledNoti"><button class="add blue ml10 fr" name="createSegment" type="button" (click)="openCreateSegmentPopup()">Create Moengage Segment</button></div>
            </ng-container>
          </div>
            <div class="salesReport">
              <div class="sendNotificationBlock">
              <div class="sendNotification">
                  <ul class="twoLi">
                      <li> 
                          <label for="type" class="control-label">Notification Type</label>
                          <angular2-multiselect
                        [data]="notificationType"
                        [(ngModel)]="selectedNotificationType"
                        [settings]="notificationTypeDropdownSettings"
                        (onSelect)="onItemSelect($event, 'notificationType')"
                        (onSelectAll)="onSelectAll($event, 'notificationType')"
                        (onDeSelect)="onItemDeSelect($event, 'notificationType')"
                        (onDeSelectAll)="onDeSelectAll($event, 'notificationType')">
                        </angular2-multiselect>
                      </li>
                  </ul>
  
                  <ul class="twoLi">
                      <li>
                          <label for="appIds" class="control-label">Target Applications</label>
                          <angular2-multiselect
                        [data]="applications"
                        [(ngModel)]="selectedApplications"
                        [settings]="applicationDropdownSettings"
                        (onSelect)="onItemSelect($event, 'application')"
                        (onSelectAll)="onSelectAll($event, 'application')"
                        (onDeSelect)="onItemDeSelect($event, 'application')"
                        (onDeSelectAll)="onDeSelectAll($event, 'application')">
                        </angular2-multiselect>
                      </li>
                  </ul>
  
                  <ng-container *ngIf="enableWebEngage">
                    <ul class="twoLi">
                      <li id="segment-dropdown">
                          <label for="segments" class="control-label">Segment (Default All)</label>
                          <angular2-multiselect
                        [data]="segments"
                        [(ngModel)]="selectedSegments"
                        [settings]="segmentDropdownSettings"
                        (onSelect)="onItemSelect($event,'segment')"
                        (onSelectAll)="onSelectAll($event,'segment')"
                        (onDeSelect)="onItemDeSelect($event, 'segment')"
                        (onDeSelectAll)="onDeSelectAll($event, 'segment')">
                        </angular2-multiselect>
                      </li>
                    </ul >
                  </ng-container>
                  <ng-container *ngIf="enableMoEngage">
                    <ul class="twoLi">
                      <li id="mo-segment-dropdown">
                          <label for="moSegments" class="control-label">Moengage Segment (Default All)</label>
                          <angular2-multiselect
                        [data]="moSegments"
                        [(ngModel)]="selectedMoSegments"
                        [settings]="moSegmentDropdownSettings"
                        (onSelect)="onItemSelect($event,'mosegment')"
                        (onSelectAll)="onSelectAll($event,'mosegment')"
                        (onDeSelect)="onItemDeSelect($event, 'mosegment')"
                        (onDeSelectAll)="onDeSelectAll($event, 'mosegment')"
                      >
                      </angular2-multiselect>
                      </li>
                    </ul >
                </ng-container>

                <ng-container *ngIf="enableCrossDomainNotification">
                  <ul class="twoLi">
                    <li id="mo-segment-dropdown">
                        <label for="crossDomains" class="control-label">Cross Domain Platforms</label>
                        <angular2-multiselect
                      [data]="crossDomains"
                      [(ngModel)]="selectedCrossDomains"
                      [settings]="crossDomainDropdownSettings"
                      (onSelect)="onItemSelect($event,'crossDomain')"
                      (onSelectAll)="onSelectAll($event,'crossDomain')"
                      (onDeSelect)="onItemDeSelect($event, 'crossDomain')"
                      (onDeSelectAll)="onDeSelectAll($event, 'crossDomain')">
                        </angular2-multiselect>
                    </li>
                  </ul >
                </ng-container>
  
                  <!--ul class="twoLi">
                      <li>
                          <label for="tags" class="control-label">Tags (Default All)</label>
                          <angular2-multiselect
                          [data]="tags"
                          [(ngModel)]="selectedTags"
                          [settings]="tagDropdownSettings"
                          (onSelect)="onItemSelect($event,'tag')"
                          (onSelectAll)="onSelectAll($event,'tag')"
                          (onDeSelect)="onItemDeSelect($event, 'tag')"
                          (onDeSelectAll)="onDeSelectAll($event, 'tag')"
                        >
                        </angular2-multiselect>
                      </li>
                  </ul-->
  
                  <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Breaking News Banner' || selectedNotificationTypeObject['name'] === 'Breaking News Text' || selectedNotificationTypeObject['name'] === 'Narrative' || selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'External'">
                      <li [class]="mandatoryFieldMessage ? 'errorInput' : ''">
                          <label for="title" class="control-label">Title</label>
                          <textarea id="title" name="title" size="20" class="form-control" [(ngModel)]="notification.title"></textarea>
                      </li>
                  </ul>
                  <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Breaking News Banner' || selectedNotificationTypeObject['name'] === 'Breaking News Text' || selectedNotificationTypeObject['name'] === 'Narrative' || selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'External'">
                      <li>
                        <label for="description" class="control-label">Description</label>
                        <textarea id="description" name="description" size="30" class="form-control" [(ngModel)]="notification.description"></textarea>
                      </li>
                  </ul>
                  <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'External'">
                      <li [class]="mandatoryFieldUrl ? 'errorInput' : ''">
                          <label for="storyUrl" class="control-label">URL</label>
                          <input id="storyUrl" name="storyUrl" class="form-control" type="text" value="" size="20" [(ngModel)]="notification.storyUrl" (keyup)="fillStoryId($event.target.value)">
                      </li>
                  </ul>
  
                  <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Breaking News Banner'|| selectedNotificationTypeObject['name'] === 'Narrative'  || selectedNotificationTypeObject['name'] === 'Breaking News Text' || selectedNotificationTypeObject['name'] === 'Video' || selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'External'">
                      <li [class]="mandatoryImageUrl ? 'errorInput' : ''">
                          <label for="imageUrl" class="control-label">Image URL</label>
                          <input id="imageUrl" name="imageUrl" class="form-control" type="text" value="" size="20" [(ngModel)]="notification.imageUrl">
                      </li>
                  </ul>
  
                  <ul class="twoLi" *ngIf="selectedNotificationTypeObject['name'] === 'Banner' || selectedNotificationTypeObject['name'] === 'Video'">
                      <li [class]="mandatoryFieldStoryId ? 'errorInput' : ''">
                          <label for="storyId" class="control-label">Story Id</label>
                          <input id="storyId" name="storyId" class="form-control" type="text" value="" size="20" [(ngModel)]="notification.storyId">
                      </li>
                  </ul>
  
              </div>
          </div>
            </div>
          </div>
          <div class="fr wid100 right padlr30 ptb15">
            <button class="cancel gray ml10" name="cancel"
              (click)="closesendNotifications()" type="button">Cancel</button>
            <button class="add blue ml10 " name="send" type="button" (click)="sendWebEngageNotification()">Send</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>